import { PartConfiguratorType } from "src/api/generated/erp/configurator/configuratorType/partConfiguratorType.ts";
import { ConfiguratorVersion } from "src/api/generated/io/aavo/applications/db/erp/types/configuratorVersion.ts";
import { JsonObject } from "src/components/views/ai/assistant/uiContext/jsonTypes.ts";

export function getSubConfiguratorVersion(
	configuratorType: PartConfiguratorType | undefined | null,
): ConfiguratorVersion | undefined {
	if (configuratorType == null) return undefined;
	if (configuratorType.type === "subConfigurator") return configuratorType.configuratorVersion ?? undefined;

	return undefined;
}

export function getPartConfiguratorAgentContextData(configuratorType: PartConfiguratorType): JsonObject {
	switch (configuratorType.type) {
		case "catalogPartTest":
			return {
				configuratorType: configuratorType.type,
				catalogPartRevisionId: configuratorType.catalogPartRevisionId,
				productFamilyVersionId: configuratorType.productFamilyVersionId,
			};
		case "configurationTemplateEditor":
			return {
				configuratorType: configuratorType.type,
				partConfigurationTemplateId: configuratorType.partConfigurationTemplateId,
			};
		case "customerOrderLine":
			return {
				configuratorType: configuratorType.type,
				customerOrderLineId: configuratorType.customerOrderLineId,
				explicitPartConfigurationId: configuratorType.explicitPartConfigurationId ?? null,
			};
		case "customerOrderOfferLine":
			return {
				configuratorType: configuratorType.type,
				customerOrderOfferLineId: configuratorType.customerOrderOfferLineId,
				explicitPartConfigurationId: configuratorType.explicitPartConfigurationId ?? null,
			};
		case "partConfigurationBomLine":
			return {
				configuratorType: configuratorType.type,
				partConfigurationBomLineId: configuratorType.partConfigurationBomLineId,
			};
		case "projectActivityMaterial":
			return {
				configuratorType: configuratorType.type,
				activityMaterialLineId: configuratorType.activityMaterialLineId,
				explicitPartConfigurationId: configuratorType.explicitPartConfigurationId ?? null,
			};
		case "purchaseOrderLine":
			return {
				configuratorType: configuratorType.type,
				purchaseOrderLineId: configuratorType.purchaseOrderLineId,
				explicitPartConfigurationId: configuratorType.explicitPartConfigurationId ?? null,
			};
		case "shopOrder":
			return {
				configuratorType: configuratorType.type,
				shopOrderId: configuratorType.shopOrderId,
				explicitPartConfigurationId: configuratorType.explicitPartConfigurationId ?? null,
			};
		case "unsavedShopOrder":
			return {
				configuratorType: configuratorType.type,
				partId: configuratorType.partId,
			};
		case "shopOrderLine":
			return {
				configuratorType: configuratorType.type,
				shopOrderLineId: configuratorType.shopOrderLineId,
				explicitPartConfigurationId: configuratorType.explicitPartConfigurationId ?? null,
			};
		case "sitePartTest":
			return {
				configuratorType: configuratorType.type,
				sitePartRevisionId: configuratorType.sitePartRevisionId,
			};
		case "sitePart":
			return {
				configuratorType: configuratorType.type,
				partId: configuratorType.partId,
			};
		case "subConfigurator":
			return {
				configuratorType: configuratorType.type,
				subConfiguratorCatalogPartId: configuratorType.subConfiguratorCatalogPartId,
			};
		case "salesPart":
			return {
				configuratorType: configuratorType.type,
				partRevisionId: configuratorType.partRevisionId ?? null,
				salesPartId: configuratorType.salesPartId,
			};
		case "unsavedCustomerOfferLine":
			return {
				configuratorType: configuratorType.type,
				customerOfferId: configuratorType.customerOfferId,
				initialValuesFromConfigurationId: configuratorType.initialValuesFromConfigurationId ?? null,
				salesPartId: configuratorType.salesPartId,
			};
		case "unsavedCustomerOrderLine":
			return {
				configuratorType: configuratorType.type,
				customerOrderId: configuratorType.customerOrderId,
				initialValuesFromConfigurationId: configuratorType.initialValuesFromConfigurationId ?? null,
				salesPartId: configuratorType.salesPartId,
			};
		case "unsavedProjectActivityMaterial":
			return {
				configuratorType: configuratorType.type,
				initialValuesFromConfigurationId: configuratorType.initialValuesFromConfigurationId ?? null,
				partId: configuratorType.partId,
				projectActivityId: configuratorType.projectActivityId,
			};
	}
}
